export default "__VITE_ASSET__DuJ4g1hk__"